import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Card,
  CardContent,
} from '@mui/material';
import { useSelector } from 'react-redux';

const SourceTable = () => {
  const treatmentPlanData = useSelector(
    (state) => state.clinicalReducer.treatmentPlan,
  );

  return (
    <div className="theme-blush">
      <div className="container-fluid">
        <Card sx={{ width: '100%', padding: 2 }}>
          <CardContent>
            <TableContainer component={Paper} sx={{ mb: 2 }}>
              <Table>
                <TableBody>
                  {/* First Row for Source of Oocyte */}
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', width: '17%' }}>
                      Source of Oocyte
                    </TableCell>
                    <TableCell sx={{ width: '17%' }}>
                      {treatmentPlanData.female}
                    </TableCell>
                    {/* <TableCell sx={{ width: '17%' }}></TableCell> Empty cell for spacing */}
                    {/* <TableCell sx={{ width: '17%' }}>OD</TableCell> */}
                  </TableRow>

                  {/* Second Row for Source of Sperm */}
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', width: '17%' }}>
                      Source of Sperm
                    </TableCell>
                    <TableCell sx={{ width: '17%' }}>
                      {treatmentPlanData.sourceOfSperm}
                    </TableCell>
                    {/* <TableCell sx={{ width: '17%' }}></TableCell> Empty cell for spacing */}
                    {/* <TableCell sx={{ width: '17%' }}>DS</TableCell> */}
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default SourceTable;
